import * as React from 'react';
import { Component, CSSProperties } from 'react';
import TrackVisibility from 'react-on-screen';

import Article from './article';
import ArticleStore from './article.store';
import AdvertisingContainer from '../../containers/advertising';

interface IContainerProps {
  className?: string;
  style?: CSSProperties;
  config: any;
  scriptSrc: any;
}
interface IContainerInjectProps extends IContainerProps {
  articleStore: ArticleStore;
}

interface IContainerState {
  domIdArticleInnerAd: string;
}

export default class Container extends Component<IContainerProps, IContainerState> {
  constructor(props) {
    super(props);
    this.state = {
      domIdArticleInnerAd: `google-${Date.now()}`,
    };
  }

  public get injected() {
    return this.props as IContainerInjectProps;
  }

  public render() {
    const articleStore: ArticleStore = this.injected.articleStore;
    const { config, scriptSrc } = articleStore;
    const Advertising = AdvertisingContainer();
    return (
          <TrackVisibility partialVisibility once>
            {
              ({ isVisible }) => {
              let hasFeatureReadMore: boolean = false;
              if (articleStore.story && articleStore.story.raw_item && articleStore.story.raw_item.language === 'russian') {
                hasFeatureReadMore = true;
              }
              return (
                <Article className={this.props.className}
                  style={this.props.style}
                  story={articleStore ? articleStore.story : null}
                  itemId = {articleStore.itemId}
                  hasFeatureReadMore={hasFeatureReadMore}
                  hasFeatureArticleInnerAd={articleStore.story && articleStore.story.raw_item ? true : false}
                  optionsArticleInnerAd={{
                    percent: 0.5,
                    reactNode: <Advertising type="article" config={config} scriptSrc={scriptSrc}/>,
                  }}
                />
              );
              }
            }

          </TrackVisibility>
    );
  }
}

function getIsServer(): boolean {
  return typeof window === 'undefined';
}
